const handSetProducts = [
  {
    tag: '',
    img: 'assets/images/products/handsets/Polycom_150.png',
    title: 'Polycom 150',
    lines: '2 lines',
    ethernetPort: 'Dual ethernet port',
    dimensions: '2.5" Grayscale display',
    extra: ''
  },
  {
    tag: 'Popular advanced phone',
    img: 'assets/images/products/handsets/Polycom_250.png',
    title: 'Polycom 250',
    lines: '4 lines',
    ethernetPort: 'Dual ethernet port',
    dimensions: '4.3" Color display',
    extra: ''
  },
  {
    tag: '',
    img: 'assets/images/products/handsets/Polycom_450.png',
    title: 'Polycom 450',
    lines: '12 lines',
    ethernetPort: 'Dual ethernet port',
    dimensions: '4.3" Color display',
    extra: ''
  },
  {
    tag: '',
    img: 'assets/images/products/handsets/Polycom_600.png',
    title: 'Polycom WX600',
    lines: '12 lines',
    ethernetPort: 'Dual ethernet port',
    dimensions: '4.3" Color touch display',
    extra: 'Dual USB port'
  },
  {
    tag: '',
    img: 'assets/images/products/handsets/Cisco_6821.png',
    title: 'Cisco 6821',
    lines: '2 lines',
    ethernetPort: 'Dual ethernet port',
    dimensions: '3.2" Grayscale display',
    extra: ''
  },
  {
    tag: 'Popular advanced phone',
    img: 'assets/images/products/handsets/Cisco_6841-51-61-71.png',
    title: 'Cisco 6841',
    lines: '4 lines',
    ethernetPort: 'Dual ethernet port',
    dimensions: '3.5" Color display',
    extra: ''
  },
  {
    img: 'assets/images/products/handsets/Cisco_6841-51-61-71.png',
    title: 'Cisco 6851',
    lines: '4 lines, KEM',
    ethernetPort: 'Dual ethernet port',
    dimensions: '3.5" Grayscale display',
    extra: ''
  },
  {
    img: 'assets/images/products/handsets/Cisco_6841-51-61-71.png',
    title: 'Cisco 6861',
    lines: '4 lines',
    ethernetPort: 'Single ethernet port',
    dimensions: '3.2" Grayscale display',
    extra: 'Wi-Fi'
  },
  {
    img: 'assets/images/products/handsets/Cisco_6841-51-61-71.png',
    title: 'Cisco 6871',
    lines: '6 lines',
    ethernetPort: 'Dual ethernet port',
    dimensions: '3.5" Grayscale display',
    extra: 'USB Port'
  },
  {
    tag: '',
    img: 'assets/images/products/handsets/Cisco_8841.png',
    title: 'Cisco 8841',
    lines: '5 lines',
    ethernetPort: 'Dual ethernet port',
    dimensions: '5" Color display',
    extra: ''
  },
  {
    tag: '',
    img: 'assets/images/products/handsets/Cisco_8851.png',
    title: 'Cisco 8851',
    lines: '5 lines, 2 KEM',
    ethernetPort: 'Dual ethernet port',
    dimensions: '5" display',
    extra: ''
  },
  {
    tag: 'Popular advanced phone',
    img: 'assets/images/products/handsets/Cisco_8861.png',
    title: 'Cisco 8861',
    lines: '5 lines, KEM',
    ethernetPort: 'Dual ethernet port',
    dimensions: '5" Color display',
    extra: ''
  },
  {
    tag: '',
    img: 'assets/images/products/handsets/Yealink_w52p.png',
    title: 'Yealink W52P',
    lines: '4 lines, Cordless',
    ethernetPort: 'Single ethernet port',
    dimensions: '1.8" Grayscale display',
    extra: '10 hour talk time'
  },
  {
    tag: '',
    img: 'assets/images/products/handsets/Polycom_8500.png',
    title: 'Polycom Trio 8500',
    lines: '3 lines',
    ethernetPort: 'Single ethernet port',
    micRange: '4.3m microphone range',
    dimensions: '5" Color display',
    extra: ''
  },
  {
    tag: '',
    img: 'assets/images/products/handsets/Polycom_8800.png',
    title: 'Polycom Trio 8800',
    lines: '5 lines',
    ethernetPort: 'Dual ethernet port',
    micRange: '6m microphone range',
    dimensions: '5" Color display',
    extra: ''
  }
]

export default handSetProducts
